import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    TextField,
    FormHelperText,
} from '@mui/material';
import EditIcon from 'common/customIcons/edit';

const FeePreview = ({ feeType, creditCardFee, exampleAmount, feeLabel, isEditing, handleLabelChange, handleLabelClick, handleLabelBlur,ccFlatFee = 0, feeError }) => {
    const calculateFee = () => {
        if (feeType === 'cash') {
            return creditCardFee;
        } else {
            return (exampleAmount * creditCardFee) / 100;
        }
    };

    const fee = calculateFee();
    const total = exampleAmount + fee;
    const totalFeeWithFlatFee = total + ccFlatFee;

    const formatCurrency = (amount) => {
        return `$${amount.toFixed(2)}`;
    };


    return (
        <Card
            variant="outlined"
            sx={{
                mb: 3,
                bgcolor: 'background.default',
                transition: 'box-shadow 0.3s ease',
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                },
            }}
        >
            <CardContent>
                <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                    sx={{ fontWeight: 500 }}
                >
                    Fee Preview
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Example purchase:
                    </Typography>
                    <Typography variant="body2" fontWeight={500}>
                        {formatCurrency(exampleAmount)}
                    </Typography>

                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    {isEditing ? (
                        <TextField
                            value={feeLabel}
                            onChange={handleLabelChange}
                            onBlur={handleLabelBlur}
                            autoFocus
                            variant="standard"
                            size="small"
                            sx={{
                                '& .MuiInputBase-input': {
                                    fontSize: '0.875rem',
                                    color: 'text.secondary',
                                    padding: 0,
                                },
                                '& .MuiInput-underline:before': {
                                    borderBottom: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                    borderBottom: 'none',
                                },
                                '& .MuiInput-underline:after': {
                                    borderBottom: 'none',
                                },
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                px: 1,
                            }}
                        />
                    ) : (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            display="flex"
                            alignItems="center"
                            gap={1}

                            border="1px solid transparent"
                        >
                            {feeLabel} <Box component="span" display="inline-flex" className="cur-pointer" onClick={handleLabelClick}><EditIcon width='16px' height='16px' /></Box>
                        </Typography>
                    )}

                    <Typography variant="body2" fontWeight={500} color="primary.main">
                        {formatCurrency(fee)}
                    </Typography>
                </Box>
                    {feeError && <FormHelperText error>{feeError}</FormHelperText>}
                {
                    feeType === "percentage" &&
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Flat fee:
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                            ${ccFlatFee}
                        </Typography>

                    </Box>
                }
                <Divider sx={{ my: 1.5 }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle2" fontWeight={600}>
                        Total:
                    </Typography>
                    <Typography variant="subtitle2" fontWeight={600}>
                        {feeType === "percentage"
                            ? formatCurrency(totalFeeWithFlatFee) :
                            formatCurrency(total)
                        }
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default FeePreview;